<div [ngClass]="{'cl-mcont': hasFilters}">
  <div class="row" [ngClass]="{'no-margin-top': hasFilters}">
    <div class="col-xs-12">
      <div class="block-flat" [ngClass]="{'no-padding': !hasFilters}">

        <form [formGroup]="form" class="form-horizontal" *ngIf="form">
          <div class="row">
            <div class="col-xs-12">
              <!-- Formulario -->
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="panel panel-default">
                    <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPn1"
                      (click)="collPn1 = !collPn1">
                      <h5 class="panel-title">
                        <i class="fas fa-paper-plane"></i>
                        <strong>{{'NEW_MESSAGE'|translate}}</strong>
                        <i class="collapse-icon fas"
                          [ngClass]="{'fa-caret-down': collPn1, 'fa-caret-up': !collPn1}"></i>
                      </h5>
                    </div>
                    <div id="collPn1" class="panel-body no-horizontal-padding collapse in">
                      <div class="form-group">
                        <div class="col-md-12 col-sm-12 col-xs-12" *ngIf="hasFilters">
                          <div class="form-group">
                            <div class="col-md-2 col-sm-12 col-xs-12">
                              <button type="button" class="btn btn-default" title="{{'SELECT_COMPANY' | translate}}"
                                (click)="selectCompanyID()">
                                <i class="fas fa-building brown"></i>
                                &nbsp;{{ 'COMPANY' | translate}}
                              </button>
                            </div>
                            <div class="col-md-3 col-sm-12 col-xs-12 no-padding-left">
                              <mat-form-field class="allwidth">
                                <input matInput formControlName="EntityName">
                              </mat-form-field>
                            </div>
                            <div class="col-md-2 col-sm-12 col-xs-12">
                              <button type="button" class="btn btn-default" title="{{'SELECT_USER' | translate}}"
                                (click)="selectUserID()" [disabled]="!form.get('EntityID').value">
                                <i class="fas fa-user blue"></i>
                                &nbsp;{{ 'USERNAME' | translate}}
                              </button>
                            </div>
                            

                            <div class="col-md-3 col-sm-12 col-xs-12 no-padding-left">
                              <mat-form-field class="allwidth">
                                <input matInput formControlName="MessageToName">
                              </mat-form-field>
                            </div>
                            <!-- Botao de envio-->
                            <div class="col-md-2 col-sm-12 col-xs-12">
                              <div *ngIf="allowCreate" class="dt-buttons margin-top-10 pull-right">
                                <button type="button" (click)="onSend()" class="btn btn-primary"
                                  title="{{'BUTTON.SEND' | translate}}" [disabled]="!form.valid ? true :  !noError">
                                  <i class="fas fa-paper-plane"></i>&nbsp;{{'BUTTON.SEND' | translate}}
                                </button>
                              </div>
                            </div>
                          </div>
                          <!--CheckBox para enviar email-->
                          
                          <div class="form-group" *ngIf="showSendNotification">
                            <div class="col-md-3 col-sm-12 col-xs-12">
                              <mat-checkbox class="full-width" formControlName="SendNotification">
                                {{sendNotificationLabel |translate}}
                              </mat-checkbox>
                            </div>
                            <div class="col-md-2 col-sm-12 col-xs-12 no-padding-left" *ngIf="showValidationSelector && !userValidationValue && isAnswering">
                              <mat-form-field class="allwidth" >
                                <mat-select class="full-width" placeholder="{{'VALIDATE'|translate}}"
                                  formControlName="UserValidated">
                                  <mat-option *ngIf="!form.get('UserValidated').hasValidator(Validators.required)" value=''></mat-option>
                                  <mat-option [value]=false>{{ 'NO' | translate }}</mat-option>
                                  <mat-option [value]=true>{{ 'YES' | translate }}</mat-option>
                                </mat-select>
                              </mat-form-field>

                              <span *ngIf="formErrors.Validate" class="field-validation-valid text-danger"
                            [translate]>{{formErrors.Validate}}</span>
                            </div>
                          </div>
                        </div>
                        <!-- Input Mensagem -->
                        <div class="col-md-10 col-sm-12"
                          [ngClass]="{'col-md-10': !hasFilters, 'col-md-12': hasfilters}">
                          <mat-form-field class='allwidth'
                            [ngClass]="{ 'mat-input-invalid': (formErrors.MessageContent || !form.controls.MessageContent.valid) && form.controls.MessageContent.dirty}">
                            <textarea matInput id="messageInput" placeholder="{{ 'MESSAGE' | translate}}"
                              formControlName="MessageContent" class="no-resize" rows="4"></textarea>
                          </mat-form-field>
                          <span *ngIf="formErrors.MessageContent" class="field-validation-valid text-danger"
                            [translate]>{{formErrors.MessageContent}}</span>
                        </div>
                        <!-- Botao de envio-->
                        <div class="col-md-2 col-sm-12 col-xs-12" *ngIf="!hasFilters">
                          <div *ngIf="allowCreate" class="dt-buttons margin-top-10 pull-right">
                            <button type="button" (click)="onSend()" class="btn btn-primary"
                              title="{{'BUTTON.SEND' | translate}}" [disabled]="!form.dirty ? true :  !noError">
                              <i class="fas fa-paper-plane"></i>&nbsp;{{'BUTTON.SEND' | translate}}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Filtros -->
          <div class="row" *ngIf="hasFilters">
            <div class="col-xs-12">
              <div class="form-group">
                <div class="col-md-10 col-sm-12">
                  <div class="form-group">
                    <!-- Data início -->
                    <div class="col-md-3">
                      <mat-form-field class="allwidth">
                        <input matInput placeholder="{{ 'BEGIN_DATE' | translate}}" formControlName="StartDate"
                          class="one date-picker" [ngClass]="{ 'input-validation-error': formErrors.StartDate }">
                          <i matSuffix class="far fa-calendar-alt bigger-110"></i>
                      </mat-form-field>
                      <span *ngIf="formErrors.StartDate"
                        class="field-validation-valid text-danger">{{formErrors.StartDate}}</span>
                    </div>
                    <!-- Data fim -->
                    <div class="col-md-3">
                      <mat-form-field class="allwidth">
                        <input matInput placeholder="{{ 'END_DATE' | translate}}" formControlName="EndDate"
                          class="one date-picker" [ngClass]="{ 'input-validation-error': formErrors.EndDate }">
                          <i matSuffix class="far fa-calendar-alt bigger-110"></i>
                      </mat-form-field>
                      <span *ngIf="formErrors.EndDate"
                        class="field-validation-valid text-danger">{{ formErrors.EndDate }}</span>
                    </div>
                    <div class="col-md-2 col-sm-12 col-xs-12">
                      <button type="button" class="btn btn-default" title="{{'SELECT_COMPANY' | translate}}"
                        (click)="selectCompanyIDToFilter()">
                        <i class="fas fa-building brown"></i>
                        &nbsp;{{ 'COMPANY' | translate}}
                      </button>
                    </div>
                    <div class="col-md-3 col-sm-12 col-xs-12 no-padding-left">
                      <mat-form-field class="allwidth">
                        <input matInput formControlName="CompanyNameToFilter">
                      </mat-form-field>
                    </div>

                  </div>
                </div>
                <!-- Botão procurar -->
                <div class="col-md-2">
                  <div class="dt-buttons pull-right">
                    <button type="button" (click)="onSearch()" class="btn btn-default">
                      <i class="fas fa-search iconSearch"></i>
                      &nbsp;{{ 'BUTTON.SEARCH' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>

        <div class="row no-margin-top">
          <div class="col-xs-12">
            <div class="table-responsive">
              <table id="tableMessages" class="table table-bordered display" cellspacing="0">
                <thead>
                  <tr>
                    <!-- ID -->
                    <th rowspan="2"></th>
                    <!-- MessageFromID -->
                    <th rowspan="2"></th>
                    <!-- HasRead -->
                    <th rowspan="2"></th>
                    <!-- OwnerID -->
                    <th rowspan="2"></th>
                    <!-- Icons => Envio/ Receção // Nova msg -->
                    <th rowspan="2"></th>
                    <!-- Data -->
                    <th class="text-center">{{ 'DATE' | translate}}</th>
                    <!-- Empresa origem (de) -->
                    <th *ngIf="hasFilters" class="text-center">{{ 'COMPANY' | translate}} {{ 'FROM' | translate}}</th>
                    <!-- De / Utilizador -->
                    <th *ngIf="!hasFilters" class="text-center">{{ 'FROM' | translate}}</th>
                    <th *ngIf="hasFilters" class="text-center">{{ 'USERNAME' | translate}} {{ 'FROM' | translate}}</th>
                    <!-- Destinatários -->
                    <th *ngIf="hasFilters" class="text-center">{{ 'COMPANY' | translate}} {{ 'TO' | translate}}</th>
                    <th *ngIf="hasFilters" class="text-center">{{ 'USERNAME' | translate}} {{ 'TO' | translate}}</th>
                    <!-- Mensagem -->
                    <th *ngIf="!hasFilters" class="text-center">{{ 'MESSAGE' | translate}}</th>
                    <th *ngIf="hasFilters" class="text-center">{{ 'MESSAGE' | translate}}</th>
                    <!-- Botões -->
                    <th class="text-center"></th>
                  </tr>
                  <tr>
                    <th>
                      <!-- Data -->
                      <mat-form-field class="full-width findInputContainer">
                        <input matInput type="text" placeholder="{{'FILTER'|translate}}" class="findInput date-pickerF">
                      </mat-form-field>
                    </th>
                    <th *ngIf="hasFilters">
                      <!-- Empresa origem -->
                      <mat-form-field class="full-width findInputContainer">
                        <input matInput type="text" placeholder="{{'FILTER'|translate}}" class="findInput">
                      </mat-form-field>
                    </th>
                    <th>
                      <!-- De / Utilizador -->
                      <mat-form-field class="full-width findInputContainer">
                        <input matInput type="text" placeholder="{{'FILTER'|translate}}" class="findInput">
                      </mat-form-field>
                    </th>
                    <th *ngIf="hasFilters">
                      <!-- Empresa destino -->
                      <mat-form-field class="full-width findInputContainer">
                        <input matInput type="text" placeholder="{{'FILTER'|translate}}" class="findInput">
                      </mat-form-field>
                    </th>
                    <th *ngIf="hasFilters">
                      <!-- Utilizador destino -->
                      <mat-form-field class="full-width findInputContainer">
                        <input matInput type="text" placeholder="{{'FILTER'|translate}}" class="findInput">
                      </mat-form-field>
                    </th>
                    <th>
                      <!-- Mensagem -->
                      <mat-form-field class="full-width findInputContainer">
                        <input matInput type="text" placeholder="{{'FILTER'|translate}}" class="findInput">
                      </mat-form-field>
                    </th>
                    <th></th>
                    <!-- Botões-->
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>